module.exports = __webpack_public_path__ + "img/swine.51077624.png";